import { Button, message, Modal, Typography } from "antd";
import { useContext } from "react";
import styled from "styled-components";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, OnboardingNavigationContext } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

function getLinkPagamento(fluxo: FluxoResposta) {
  const venda = fluxo.dadosPreenchidos?.venda as
    | {
        checkout?:
          | string
          | { linkPagamento?: string; url?: string; checkoutUrl?: string };
      }
    | undefined;
  const checkout = venda?.checkout;

  if (typeof checkout === "string") {
    return checkout;
  }

  return checkout?.linkPagamento ?? checkout?.url ?? checkout?.checkoutUrl;
}

const Conteudo = styled.div`
  display: grid;
  gap: 24px;
  max-width: 680px;

  .descricao {
    color: #42535b;
    font-size: 16px;
    line-height: 1.65;
    margin: 0;
  }

  .acoes-principais {
    display: grid;
    gap: 12px;
    justify-items: start;
  }

  .acao-secundaria {
    justify-self: start;
    padding-inline: 0;
  }

  .rodape {
    border-top: 1px solid #e1e8ea;
    padding-top: 20px;
  }
`;

export function EtapaPagamentoPendente({
  fluxo,
  submitting,
  onConcluir,
}: Props) {
  const { onVoltar } = useContext(OnboardingNavigationContext);

  function confirmarCancelamento() {
    Modal.confirm({
      title: "Cancelar ativação?",
      content:
        "A ativação pendente será cancelada e o anúncio não será publicado.",
      okText: "Cancelar ativação",
      okButtonProps: { danger: true },
      cancelText: "Manter ativação",
      onOk: () => onConcluir({ acao: "CANCELAR_ATIVACAO" }),
    });
  }

  function irParaPagamento() {
    const linkPagamento = getLinkPagamento(fluxo);

    if (!linkPagamento) {
      message.error("Não foi possível obter o link de pagamento. Tente novamente.");
      return;
    }

    window.location.assign(linkPagamento);
  }

  return (
    <OnboardingFrame
      fluxo={fluxo}
      title="Estamos aguardando a confirmação do pagamento"
    >
      <Conteudo>
        <Typography.Paragraph className="descricao">
          Ainda não recebemos a confirmação do pagamento da sua assinatura.
        </Typography.Paragraph>

        <Typography.Paragraph className="descricao">
          Se você já realizou o pagamento, <strong>não precisa esperar</strong>: pode continuar preenchendo as informações do seu anúncio. Ele será publicado somente após a confirmação do pagamento.
        </Typography.Paragraph>

        <div className="acoes-principais">
          <Button
            type="primary"
            size="large"
            loading={submitting}
            onClick={() => onConcluir({ acao: "CONTINUAR_CADASTRO" })}
            style={{ minWidth: 220, borderRadius: 999, background: "#003644" }}
          >
            Continuar cadastro
          </Button>
          <Button
            size="large"
            disabled={submitting}
            onClick={irParaPagamento}
            style={{ minWidth: 250, borderRadius: 999 }}
          >
            Ir novamente para o pagamento
          </Button>
        </div>

        <Button
          type="text"
          className="acao-secundaria"
          disabled={submitting}
          onClick={confirmarCancelamento}
        >
          Cancelar ativação
        </Button>

        {onVoltar ? (
          <div className="rodape">
            <Button size="large" disabled={submitting} onClick={onVoltar}>
              Voltar
            </Button>
          </div>
        ) : null}
      </Conteudo>
    </OnboardingFrame>
  );
}
